<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <img class="mr-3 ml-2" style="width: 30px;" src='assets/ico/jira-icon-white.svg' alt="icon" />
                    <span class="modal-title" id="modal-basic-title">
                        <span> {{'jiraUsers.title' | translate }} </span>
                    </span>
                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body mb-5">
        <div class="row m-0 mb-5 pl-5 pr-5 pt-2">
            {{'jiraUsers.content' | translate }}
            <div class="col-lg-12 p-0 mt-3 mb-3">
                <div ngbDropdown placement="bottom-left">
                    <div>
                        <input name="searchOption" ng-control="options" type="radio" 
                            [value]=false  
                            [(ngModel)]="searchOption" 
                            (ngModelChange)="isLoading=true; result=[]; form.reset(); this.quickSearch.next({ value: searchValue})"
                            checked>
                            &nbsp;{{'jiraUsers.searchByName' | translate }}&nbsp;&nbsp;
                        <input name="searchOption" ng-control="options" type="radio" 
                            [value]=true 
                            [(ngModel)]="searchOption" 
                            (ngModelChange)="isLoading=true; result=[]; form.reset(); this.quickSearch.next({ value: searchValue })">
                            &nbsp;{{'jiraUsers.searchById' | translate }}<br/><br/>
                        <form autocomplete="off">
                            <input class="search-input form-control" type="text" name="quick-search" id="quick-search"
                                [placeholder]="'buttons.jiraUsers' | translate" [(ngModel)]="searchValue"
                                (ngModelChange)="isLoading=true; result=[]; form.reset(); this.quickSearch.next({ value: $event })">
                        </form>
                        
                        <div *ngIf="isLoading && searchValue.length > 0" class="ng-spinner-loader"></div>
                        <div ngbDropdownMenu aria-labelledby="quick-search"
                            [ngClass]="!userSelected && searchValue.length > 0 ? 'show' : ''" class="scrollable-menu"
                            role="menu" placement="bottom-left" style="width: max-content;">
                            <div ngbDropdownItem *ngFor="let res of result">
                                <div class="menu-button" (click)="selectUser(res)">
                                    <div class="data-row" [innerHTML]="constructDisplayName(res)">
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="(result.length === 0 && searchOption==false || result.length === 0 && searchOption==true && searchValue.length==8) && !isLoading && !userSelected" ngbDropdownItem>
                                <div class="row menu-button">
                                    {{'buttons.noResults' | translate}}
                                </div>
                            </div>
                        </div>
                        <button class="btn closeSearch" (click)="closeSearch()">
                            <div [inlineSVG]="'assets/ico/clear-button.svg'" class="icon icon-black clear-search-icon"
                                alt="clear"></div>
                        </button>
                    </div>
                </div>

                <div *ngIf="userSelected" class="col-lg-12 p-0 mt-4 mb-3">
                    <div>{{'jiraUsers.jiraGroups' | translate }}</div>
                    <div style="font-size: 14px;font-style: italic;color: #777777;">{{'jiraUsers.jiraGroupsDesc' |
                        translate }}</div>
                    <ng-template ngFor let-item [ngForOf]="jiraGroups" let-i="index">
                        <div class="jira-group mt-3">
                            <!--<input class="status-checkbox" type="checkbox" [(ngModel)]="item.default"
                                [ngModelOptions]="{standalone: true}" />-->
                            <div [ngbTooltip]="item.descString ? jiraGroupTooltip : null" #t="ngbTooltip" tooltipClass="animation-tooltip jira-group-tooltip" placement="right"
                                triggers="hover" style="display: inline; cursor: pointer; padding-right: 5px;"
                                (click)="item.default = !item.default"><b>{{item.name}}</b></div>
                            <ng-template #jiraGroupTooltip>
                                <div [innerHTML]="item.descString"></div>
                            </ng-template>
                        </div>
                        <ng-template ngFor let-item2 [ngForOf]="item.features" let-i="index">
                            <div class="jira-features mt-3">
                                <input class="status-checkbox" type="checkbox" [(ngModel)]="item2.default"
                                    [ngModelOptions]="{standalone: true}" />
                                <div [ngbTooltip]="item2.descString ? jiraGroupTooltip : null" #t="ngbTooltip" tooltipClass="animation-tooltip jira-group-tooltip" placement="right"
                                    triggers="hover" style="display: inline; cursor: pointer; padding-right: 5px;"
                                    (click)="item2.default = !item2.default">{{item2.label}}</div>
                                    <ng-template #jiraGroupTooltip>
                                        <div [innerHTML]="item2.descString"></div>
                                    </ng-template>
                            </div>
                        </ng-template>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="modal-footer p-0">
            <div class="container-fluid m-0 p-0">
                <app-modal-info title="Confirm action" (click)="hideMainModal()"
                    [text]="'Are you sure you want to activate user for <b>' + form.value.jiraUser?.displayName + '</b>?'"
                    color="blue" [isQuestion]="true" [overlayTop]="true" iconSrc="assets/ico/jira-icon-white.svg"
                    [iconClass]="'jira-icon-modal'" (confirmEvent)="activateJiraUser(form.value.jiraUser)"
                    (dissmisModalEvent)="this.close()">
                    <span action>
                        <button class="btn modal-btn save" [disabled]="!form.value.jiraUser">{{'buttons.activate' |
                            translate}}</button>
                    </span>
                </app-modal-info>
                <span class="btn modal-btn save back" (click)="close()">{{'buttons.cancel' | translate }}</span>
            </div>
        </div>

    </div>
</div>